var _g, _circle, _path, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVehicleLocationWithBg(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    filter: "url(#filter0_d_6380_31664)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 28,
    fill: "#00A4FD"
  }))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 32,
    cy: 28,
    r: 23,
    fill: "#00A4FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.2846 35.5V37.875C21.2846 38.0993 21.2088 38.2874 21.057 38.4391C20.9053 38.5908 20.7173 38.6667 20.493 38.6667H20.1276C19.9033 38.6667 19.7153 38.5908 19.5635 38.4391C19.4118 38.2874 19.3359 38.0993 19.3359 37.875V26.2435L22.4781 17.2917C22.5554 17.04 22.7041 16.8451 22.9242 16.7071C23.1445 16.5691 23.3897 16.5 23.6596 16.5H28.714V14.0641H35.4127V16.5H40.4675C40.7071 16.5 40.9247 16.5726 41.1202 16.7178C41.3158 16.8629 41.4514 17.0542 41.5271 17.2917L44.6693 26.2435V37.875C44.6693 38.0993 44.5934 38.2874 44.4417 38.4391C44.2899 38.5908 44.1019 38.6667 43.8776 38.6667H43.5123C43.2879 38.6667 43.0999 38.5908 42.9482 38.4391C42.7965 38.2874 42.7206 38.0993 42.7206 37.875V35.5H21.2846ZM21.5771 24.6601H42.4281L40.0958 18.0834H23.9094L21.5771 24.6601ZM24.7628 31.8461C25.2555 31.8461 25.6718 31.6738 26.0117 31.3291C26.3518 30.9842 26.5219 30.5656 26.5219 30.0732C26.5219 29.5805 26.3494 29.1642 26.0045 28.8243C25.6599 28.4842 25.2412 28.3141 24.7486 28.3141C24.2561 28.3141 23.8399 28.4865 23.4997 28.8314C23.1598 29.1761 22.9899 29.5947 22.9899 30.0874C22.9899 30.5798 23.1622 30.9961 23.5068 31.3363C23.8517 31.6762 24.2704 31.8461 24.7628 31.8461ZM39.2566 31.8461C39.7491 31.8461 40.1653 31.6738 40.5055 31.3291C40.8454 30.9842 41.0153 30.5656 41.0153 30.0732C41.0153 29.5805 40.843 29.1642 40.4984 28.8243C40.1535 28.4842 39.7348 28.3141 39.2424 28.3141C38.7497 28.3141 38.3334 28.4865 37.9935 28.8314C37.6534 29.1761 37.4833 29.5947 37.4833 30.0874C37.4833 30.5798 37.6558 30.9961 38.0007 31.3363C38.3453 31.6762 38.764 31.8461 39.2566 31.8461ZM20.9193 33.9167H43.0859V26.2435H20.9193V33.9167Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6380_31664",
    x: 0,
    y: 0,
    width: 64,
    height: 64,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6380_31664"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6380_31664",
    result: "shape"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleLocationWithBg);
export default __webpack_public_path__ + "static/media/vehicle-location-with-bg.afe218ffa31991e2a918766b728e6932.svg";
export { ForwardRef as ReactComponent };